import { gql } from "@apollo/client";

export const VALIDATE_CONTRATO_PP_HAS_PLAN = gql`
query validateContratoPPHasPlan($idEvaluacion: Int!) {
    validateContratoPPHasPlan(idEvaluacion: $idEvaluacion)
}`;